import React from 'react';
import { BottomSheet as BottomSheetNew } from './BottomSheet';
import { convertOldBottomSheetProps } from './converter.old';
import type { OldBottomSheetProps } from './converter.old';

export type BottomSheetProps = OldBottomSheetProps;

export const BottomSheet = (props: BottomSheetProps) => <BottomSheetNew {...convertOldBottomSheetProps(props)} />;
